// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconSpinner_loader__2OIKC","root":"IconSpinner_root__2OyUl"};